import { useEffect, useState } from "react";
import { AppBar, Box, Container, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { MenuItem } from "./MenuItem";

const Logo = ({ height }: { height: { xs: number; md: number } }) => (
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL || ""}/img/logo.jpg`}
    alt="Signacole"
    width={110}
    height={104}
    decoding="async"
    sx={{
      height: height,
      width: "auto",
      maxWidth: { xs: 72, md: 110 },
      objectFit: "contain",
      display: "block",
      backgroundColor: "#fff",
    }}
  />
);

const Header = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <Box
        component="a"
        href="#contenido"
        sx={{
          position: "absolute",
          left: 16,
          top: -48,
          zIndex: 2000,
          bgcolor: "primary.main",
          color: "primary.contrastText",
          px: 2,
          py: 1,
          borderRadius: 1,
          "&:focus": {
            top: 16,
          },
        }}
      >
        Saltar al contenido
      </Box>
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: "#FFFFFF",
          color: "text.primary",
          borderBottom: "1px solid",
          borderColor: "divider",
          overflow: "visible",
          zIndex: 1400,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            sx={{
              minHeight: { xs: 72, md: 96 },
              py: 1,
              overflow: "visible",
            }}
          >
            <Box
              component={Link}
              to="/"
              aria-label="Inicio Signacole"
              onClick={() => setOpen(false)}
              sx={{
                display: "flex",
                alignItems: "center",
                mr: 2,
                flexShrink: 0,
              }}
            >
              <Logo height={{ xs: 56, md: 80 }} />
            </Box>

            <Box sx={{ flexGrow: 1 }} />

            <Box sx={{ display: { xs: "none", lg: "flex" }, alignItems: "center", gap: 0.5 }}>
              <MenuItem />
            </Box>

            <IconButton
              onClick={() => setOpen((value) => !value)}
              aria-label={open ? "Cerrar menú" : "Abrir menú"}
              aria-expanded={open}
              aria-controls="menu-principal-movil"
              sx={{ display: { lg: "none" }, color: "text.primary" }}
            >
              {open ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Box
        id="menu-principal-movil"
        role={open ? "dialog" : undefined}
        aria-modal={open ? true : undefined}
        aria-label={open ? "Menú principal" : undefined}
        aria-hidden={!open}
        sx={{
          display: { xs: "block", lg: "none" },
          position: "fixed",
          top: { xs: 72, md: 96 },
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1390,
          bgcolor: "#FFFFFF",
          overflowY: "auto",
          px: 2.5,
          pt: 1.5,
          pb: 3,
          opacity: open ? 1 : 0,
          visibility: open ? "visible" : "hidden",
          pointerEvents: open ? "auto" : "none",
          transform: open ? "translateY(0)" : "translateY(-8px)",
          transition: "opacity 0.28s ease, transform 0.28s ease, visibility 0.28s ease",
        }}
      >
        <MenuItem variant="mobile" onClose={() => setOpen(false)} />
      </Box>
    </>
  );
};

export default Header;
